import React from 'react'
import styled from '@emotion/styled'

export interface RowProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
  style?: React.CSSProperties
}

const StyledRow = styled.div<RowProps>`
  gap: 16px;
  flex: 1;
  display: flex;
  flex-direction: row;
`

const Row: React.FC<RowProps> = ({ children, ...rest }) => {
  return <StyledRow {...rest}>{children}</StyledRow>
}

export default Row
